import { render, staticRenderFns } from "./ListaUsuarios.vue?vue&type=template&id=12c80667&scoped=true&"
import script from "./ListaUsuarios.vue?vue&type=script&lang=js&"
export * from "./ListaUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./ListaUsuarios.vue?vue&type=style&index=0&id=12c80667&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c80667",
  null
  
)

export default component.exports